export default function (instance) {
  return {
    submitQuestion (fromEmail, title, question) {
      return instance
        .post('api/user/support', {
          fromEmail,
          title,
          question
        })
        .then(response => response.data)
    }
  }
}
